<template>
    <v-dialog v-model="showPopup" max-width="600px" :persistent="docName ? true : false">
        <div class="popup">
            <div class="popup-header">
                <div class="nn-title">New {{ flowtype }}</div>
                <button class="circle" @click="showPopup = false">
                    <img :src="require('@/assets/icons/close.svg')" alt="">
                </button>
            </div>
            <v-form v-model="isFormValid" class="popup-body">

                <div class="popup-input">
                    <div class="label">Document Name <span class="optional">(Optional)</span></div>
                    <v-text-field v-model="docName" :rules="[nameRules]" placeholder="eg: New product launch overview"
                        variant="outlined" density="compact" bg-color="var(--bg-color)"></v-text-field>
                </div>

                <div v-if="flowtype === 'Press Release'" class="popup-input">
                    <div class="label">Select Press Release Type
                        <span class="required">*</span>
                    </div>
                    <v-select v-model="prType" :items="prOptions" :rules="selectRules" item-title="typeName"
                        item-value="typeId" placeholder="Choose from options" variant="outlined" density="compact"
                        bg-color="var(--bg-color)"></v-select>
                </div>

            </v-form>
            <div class="popup-footer">
                <button class="add-new-btn" @click.prevent="showPopup = false">
                    <span>Cancel</span>
                </button>

                <button class="add-new-btn-continue" :disabled="btnLoader || !isFormValid"
                    @click="handleCreateService()">
                    <span>Create</span>
                    <v-progress-circular v-if="btnLoader" indeterminate :size="18"
                        :width="2"></v-progress-circular>
                </button>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import axiosInstance from '@/axiosInterceptor';

export default {
    name: 'CreatePopup',
    props: {
        modelValue: {
            type: Boolean
        },
        flowtype: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            docName: null,
            isFormValid: false,
            btnLoader: false,
            prOptions: [],
            selectRules: [
                v => !!v || 'This field is required',
                v => v.length > 0 || 'This field is required'
            ],
            prType: null,
        }
    },
    computed: {
        showPopup: {
            get() {
                return this.modelValue;
            },
            set(value){
                if (!value) {
                    this.resetPopupData();
                }
                this.$emit('update:modelValue', value);
            }
        },
        nameRules() {
            return (value) => {
                if (value && value.length < 3) return "Document name must be at least 3 characters";
                else if (value && value.length > 100) return 'Document name must be less than 100 characters';
                else return true;
            }
        },
    },
    methods: {
        handleCreateService() {
            this.btnLoader = true;
            if(this.flowtype === 'Press Release') {
                this.$emit('create', { docName: this.docName, prType: this.prType })
            } else {
                this.$emit('create', this.docName)
            }
        },

        resetPopupData() {
            this.docName = null;
        },

        async fetchPrTypes() {
            await axiosInstance.get('/category')
                .then((response) => {
                    this.prOptions = response.data.data;
                });
        },
        
    },
    async mounted() {
        await this.fetchPrTypes();
    }
}
</script>

<style scoped>
.popup {
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E0E9ED;
    border-radius: 8px;
}

.popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    font-weight: 600;
    font-family: 'OverpassMono';
    font-size: 20px;
}

.optional {
    opacity: 0.4;
}

.circle {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 8px;
    border: 2px solid #D4D4D4;
}

.popup-body {
    display: flex;
    flex-direction: column;
    padding: 16px;
    overflow: auto;
    height: 100%;
}

.popup-input {

    display: flex;
    flex-direction: column;
    gap: 12px;
    font-weight: 500;
}

.popup-footer {
    display: flex;
    justify-content: space-between;
    gap: 1em;
    padding: 16px;
}

.add-new-btn-continue {
    display: flex;
    align-items: center;
    gap: 25px;
    justify-content: center;
    width: 50%;
    background: #171717;
    color: white;
    border: 1px solid #525252;
    border-radius: 8px;
    font-weight: 500;
}

.add-new-btn {
    width: 50%;
    padding: 12px;
    background: white;
    border: 1px solid #525252;
    border-radius: 8px;
    font-weight: 500;
}

</style>